import TrendingListingCard from './TrendingListingCard.component';

export default TrendingListingCard;